import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton } from '@mui/material';
import { bgBlur } from '../../../utils/cssStyles';
import AccountPopover from './AccountPopover';
import { ICONS } from 'src/assets/library';
import NotificationMenuPopover from 'src/components/menu/notification-menu';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const NAV_WIDTH = 250;

const HEADER_MOBILE = 50;

const HEADER_DESKTOP = 60;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav }) {
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();

  return (
    <StyledRoot>
      <StyledToolbar>
        <IconButton
          size="small"
          onClick={onOpenNav}
          sx={{
            ml: -1,
            color: 'text.primary',
            display: { lg: 'none' },
          }}
        >
          {ICONS.NavBtn}
        </IconButton>
        {user.role === 'EMPLOYEE' && location.pathname === '/booking' ? (
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              fontSize: {
                xs: '0.8rem',
                sm: '1rem',
              },
              paddingTop: {
                sm: 0,
                xs: '0.8rem',
              },
              paddingX: '0.6rem',
              color: '#1890ff',
              fontWeight: 600,
            }}
            className="message"
          >
            Refresh this page to display updated booking info
          </Box>
        ) : (
          <Box sx={{ flexGrow: 1 }} />
        )}
        <NotificationMenuPopover />
        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          <AccountPopover />
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
